<template>
    <div>
        <div class="card">
            <div class="card-header">Applicant Information</div>
            <div class="card-body">
                <b-row>
                    <b-col cols="12">
                        <p>
                            Application for Licensure as {{application.license.licenseType.description}} with license category of {{application.subCategory}}
                        </p>
                        <p v-if="application.applyMethod !== null">
                            Applying by {{application.applyMethod.description}}
                        </p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="4"><BaseTextOutput label="Last Name" :value="application.lastName"/></b-col>
                    <b-col cols="4"><BaseTextOutput label="First Name" :value="application.firstName"/></b-col>
                    <b-col cols="4"><BaseTextOutput label="Middle Name" :value="application.middleName"/></b-col>
                </b-row>

                <Address :value="application.address" :international="application.international"/>

                <b-row class="mt-3">
                    <b-col cols="4"><BaseTextOutput label="Preferred Phone" :value="application.preferredPhone"/></b-col>
                    <b-col cols="4"><BaseTextOutput label="Email Address" :value="application.emailAddress"/></b-col>
                </b-row>

                <b-row>
                    <b-col cols="4"><BaseTextOutput label="Social Security Number" :value="application.license.socialSecurityNumber"/></b-col>
                    <b-col cols="4"><BaseTextOutput label="Date of Birth" :value="application.license.dateOfBirth"/></b-col>
                </b-row>

                <h2 class="mt-3">Other Names</h2>
                <OtherNames :value="application.otherNames"/>

                <h2 class="mt-3">Trade Names</h2>
                <TradeNames :value="application.tradeNames"/>

                <h2 class="mt-4">Attachments</h2>
                <AttachmentList :value="application.attachments"/>

                <h2 class="mt-4">Internal Attachments</h2>
                <AttachmentList :value="application.internalAttachments" :internal="true"/>

            </div>
        </div>

        <div class="card" v-if="!readonly">
            <div class="card-header" id="intAttachmentsDesc">Upload Attachments</div>
            <div class="card-body">
                <FileAttachmentInternal v-on:attachment-added="addAttachment" :appId="application.applicationId"
                                        describedby="intAttachmentsDesc"/>
            </div>
        </div>

        <div class="card" v-if="application.subCategory != 'FULL'">
            <div class="card-header">Minnesota Licensed {{ssLabel}}(s) & Establishment(s)</div>
            <div class="card-body">
                <div v-for="(supervisor, index) in application.mnSupervisor" :key="supervisor.id"
                     v-bind:class="{'border-bottom':index !== application.mnSupervisor.length-1, 'mt-3': index !== 0}">
                    <b-row>
                        <b-col cols="6">
                            <BaseTextOutput label="Supervisor" :value="supervisor.formattedAffirmation"/>
                        </b-col>
                        <b-col cols="6" v-if="application.subCategory === 'GUEST'">
                            <BaseTextOutput label="Work Dates" :value="supervisor.workDate.startDate + ' thru ' + supervisor.workDate.endDate"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2"><BaseTextOutput label="Received Date" :value="supervisor.receivedDate"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Establishment Name" :value="supervisor.establishment.supervisedEstName"/></b-col>
                        <b-col cols="6"><BaseTextOutput label="Establishment Address" :value="supervisor.establishment.supervisedEstFullAddress"/></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Establishment License Number" :value="supervisor.establishment.supervisedEstLicense"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Establishment Phone" :value="supervisor.establishment.supervisedEstPhoneNumber"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Establishment Website" :value="supervisor.establishment.supervisedEstWebsite"/></b-col>
                        <b-col cols="4">
                            <label style="margin-bottom:1px;"><strong>Establishment Hours</strong></label>
                            <b-row v-for="hrs in supervisor.establishment.establishmentHours" :key="hrs.id">
                                <b-col cols="12">
                                    {{hrs.days.map(d => d.description).join(', ') + ': ' + hrs.hours}}
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <div class="card" v-if="application.subCategory === 'FULL'">
            <div class="card-header">Employment History</div>
            <div class="card-body">             
                <Employers :value="application.employers"/>
            </div>
        </div>

         <div class="card">
            <div class="card-header">Applicant Questionnaire</div>
            <div class="card-body">
                <QuestionResponses :value="application.questionResponses" />
            </div>
        </div>

        <div class="card" v-if="application.additionalInformation">
            <div class="card-header">Additional Information</div>
            <div class="card-body">
                {{application.additionalInformation}}
            </div>
        </div>     
    </div>
</template>

<script>
import moment from 'moment'
import Address from '@/components/templates/Address.vue'
import OtherNames from '@/components/templates/OtherNames.vue'
import TradeNames from '@/components/templates/TradeNames.vue'
import AttachmentList from '@/components/templates/AttachmentList.vue'
import Employers from '@/components/templates/Employers.vue'
import QuestionResponses from '@/components/templates/QuestionResponses.vue'
import FileAttachmentInternal from '@/components/templates/input/FileAttachmentInternal.vue'

export default {
    components: {
        Address,
        OtherNames,
        AttachmentList,
        Employers,
        QuestionResponses,
        TradeNames,
        FileAttachmentInternal
    },
    props: {
        application: Object,
        readonly: Boolean
    },
    data: () => ({
        
    }),

    computed: {
        ssLabel() {
            if (this.application.subCategory == 'GUEST') {
                return "Sponsor" 
            } else {
                return "Supervisor"
            }
        }
    },

    methods: {
        addAttachment(value) {
            if (value.internal) {
                this.application.internalAttachments.push(value)
            } else {
                this.application.attachments.push(value)
            }

        },
    }
}
</script>
<style>
</style>